import Banner from "../components/Program-Teaching/Banner";
import Section from "../components/Program-Teaching/Section";
import Section2 from "../components/Program-Teaching/Section2";
import Section3 from "../components/Program-Teaching/Section3";
import Section4 from "../components/Program-Teaching/Section4";
import Section5 from "../components/Program-Teaching/Section5";
import LinkingPage from "../components/Program-Teaching/LinkingPage";

const ProgramTeaching = () => {
  return (
    <>
      <Banner />
      <Section />
      <Section2 />
      <Section3 />
      <Section4 />
  
    </>
  );
};

export default ProgramTeaching;
